import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../PricingHub/SearchComponent';

class TEExpenseDataSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
  ];

  btnSpan = 'col-md-6';
}

TEExpenseDataSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

TEExpenseDataSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(TEExpenseDataSearchForm);
